export const shadows = {
    '2xl': {
        value: '0px 4px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.12)',
    },
    searchBar: {
        value: '0px 0px 32px 0px rgba(0, 0, 0, 0.15)',
    },
    sticky: {
        value: '0 0 12px rgba(0, 0, 0, 0.06)',
    },
    stickyHeader: {
        value: '0 8px 8px 0 rgba(23, 35, 44, 0.08), 0 2px 2px 0 rgba(23, 35, 44, 0.10)',
    },
    tile: {
        value: '0 0 10px 0 rgba(0, 0, 0, 0.12)',
    },
};
